export default {
    send: 'Gönder',
    couponSendedText: 'Anketimize katıldığınız için teşekkür ederiz. Ödül kodunuzu "Ödüllerim" sekmesinden görüntüleyebilirsiniz.',
    validations: {
        required: 'Bu alanı doldurmak zorunludur.',
        email: "Lütfen geçerli bir {field} giriniz",
        digits: "{field}, {length} rakamdan oluşmalıdır",
        alpha: "{field}, alfabetik karakterlerden oluşmalıdır",
        phoneNumber: "Lütfen geçerli bir telefon numarası giriniz",
        regex: 'Lütfen geçerli bir {field} giriniz',
        length: `{field}, {rule.length} uzunluğunda olmalı`,
        tcNumber: "Girilen Kimlik Numarası geçersiz",
        iban: 'Girilen IBAN geçersiz.',
        isValid: `Bu alanı doldurabilmek için {rule[0]} alanını işaretleyin.`,
        minCharacter: `En az {min} karakter uzunluğunda olmalıdır.`
    },
    contactUs: {
        subject: 'Konu',
        message: 'Mesaj',
        email: 'E-posta',
        preWrittenMessage: "Hesabımı silmek istiyorum çünkü ... ",
        accountDeletion: 'Hesap Silme',
    }
}